import Typography from '@mui/material/Typography';
import { useTasksByFilterDocument } from 'features/tasks';
import { defaultFilter } from 'pages/today/constants';
import React, { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';
import {
  DocumentOrganizationKeys,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import { TaskType } from 'shared/types/task-base';

import * as Styled from './today-count.style';

export const LoadingTodayCount: React.FC = () => <Styled.Container $loading />;

export const TodayCount: React.FC = () => {
  const today = useToday();
  const user = useUser();

  const filterDocument = useMemo(() => {
    const defaultFilterDocument = defaultFilter(today);
    // when the user sets hideHabits for today, this should be taken into account on the today count as well
    if (user?.settings?.todayHideHabits) {
      return {
        ...defaultFilterDocument,
        [DocumentOrganizationKeys.Filters]: {
          ...defaultFilterDocument[DocumentOrganizationKeys.Filters],
          [FilterOptionKeys.Type]: {
            include: Object.values(TaskType).filter(
              (type) => type !== TaskType.Habit,
            ),
          },
        },
      };
    }

    return defaultFilterDocument;
  }, [today, user?.settings?.todayHideHabits]);

  const tasks = useTasksByFilterDocument(filterDocument, {
    includeTaskWithAction: true,
    excludeHiddenTodoHabits: true,
  });

  return !!tasks.length ? (
    <Styled.Container>
      <Typography variant="overline" component="span">
        {tasks.length}
      </Typography>
    </Styled.Container>
  ) : null;
};
